module.exports = __webpack_public_path__ + "static/media/sebi.3f379c9e.pdf";